import { api } from "./client";

export interface Transfer {
  id: string;
  vessel_id: string | null;
  vessel_name: string | null;
  recipient_email: string;
  description: string;
  r2_key: string | null;
  download_token: string;
  expires_at: string;
  status: "pending" | "in_transit" | "delivered" | "cancelled";
  downloaded_at: string | null;
  created_by: string;
  created_at: string;
}

export const transfersApi = {
  list: () => api.get<Transfer[]>("/api/transfers"),

  get: (id: string) => api.get<Transfer>(`/api/transfers/${id}`),

  upload: (file: File) => {
    const fd = new FormData();
    fd.append("file", file);
    return api.multipart<{ r2Key: string; fileName: string; fileSize: number }>(
      "/api/transfers/upload",
      fd
    );
  },

  create: (body: {
    vesselId?: string;
    recipientEmail: string;
    description: string;
    expiresInHours?: number;
    r2Key?: string;
  }) => api.post<{ id: string; downloadToken: string; expiresAt: string }>("/api/transfers", body),

  updateStatus: (id: string, status: Transfer["status"]) =>
    api.patch<{ ok: boolean }>(`/api/transfers/${id}/status`, { status }),

  delete: (id: string) => api.delete<{ ok: boolean }>(`/api/transfers/${id}`),
};
